import * as t from "io-ts";
import decimal from "./decimal";
import { isoDateTime } from "./date-time";
import nullable from "./nullable";
import { uuidT } from "./uuid";
const positionT = t.strict({
    lat: t.number,
    lon: t.number,
});
export const driverActivityCommonPropsT = t.intersection([
    t.strict({
        trailerId: uuidT,
        position: nullable(positionT),
    }),
    t.partial({
        time: nullable(isoDateTime),
    }),
]);
export const addEditNoteActivityT = t.intersection([
    driverActivityCommonPropsT,
    t.strict({
        note: t.string,
    }),
]);
export const addEditVolumeActivityT = t.intersection([
    driverActivityCommonPropsT,
    t.strict({
        cubicMeters: decimal,
    }),
]);
export const addEditWeightActivityT = t.intersection([
    driverActivityCommonPropsT,
    t.strict({
        weightInKg: decimal,
    }),
]);
export const addEditInvoiceRefActivityT = t.intersection([
    driverActivityCommonPropsT,
    t.strict({
        ref: t.string,
    }),
]);
export const startTripActivityT = t.intersection([
    driverActivityCommonPropsT,
    t.strict({
        odometer: t.number,
        note: nullable(t.string),
    }),
]);
export const endTripActivityT = t.intersection([
    driverActivityCommonPropsT,
    t.strict({
        odometer: nullable(t.number),
        note: nullable(t.string),
    }),
]);
export const arrivedActivityT = driverActivityCommonPropsT;
export const departedActivityT = driverActivityCommonPropsT;
export const stopCompletedActivityT = driverActivityCommonPropsT;
//# sourceMappingURL=driver-activities.js.map